import { CaretDown, ClockCounterClockwise } from "@phosphor-icons/react";
import { clsx } from "clsx";
import { useState } from "react";

import { Licenses } from "common/components/subscriptions";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import { useCampaignContext } from "common/helpers/CampaignContext";

import useCampaignValidation from "../../../../hooks/useCampaignValidation";
import CampaignStart from "./CampaignStart";

export default function StartCampaignButton() {
  const [isLicensesModalOpen, setIsLicensesModalOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isScheduled, setIsScheduled] = useState<boolean>();

  const { owners } = useCampaignContext();

  const {
    workerAccountsWithoutSeat,
    missingSeatsCount,
    hasInsufficientLicenses,
  } = useCampaignValidation(owners);

  function onStartCampaign(shouldSchedule: boolean) {
    if (hasInsufficientLicenses) {
      setIsLicensesModalOpen(true);
      return;
    }

    setIsScheduled(shouldSchedule);
    setIsDialogOpen(true);
  }

  return (
    <>
      <div className="group flex rounded-full bg-black-950">
        <button
          type="button"
          className="rounded-l-full pl-5 pr-2.5 text-button-sm text-white transition-colors duration-300 hover:bg-black-700"
          onClick={() => onStartCampaign(false)}
        >
          Start
        </button>
        <DropdownMenu>
          <DropdownMenuTrigger
            aria-label="more-start-campaign-options"
            type="button"
            className={clsx(
              "group relative h-10 rounded-r-full p-2.5 transition-colors duration-300 data-[state=open]:bg-black-700 hover:bg-black-700",
              "before:absolute before:left-0 before:h-5 before:w-px before:bg-black-700 before:opacity-100 before:transition-opacity before:duration-300 before:ease-in-out before:group-hover:opacity-0",
            )}
          >
            <CaretDown className="size-5 fill-white transition-transform group-data-[state=open]:rotate-180" />
          </DropdownMenuTrigger>
          <DropdownMenuContent className="z-aboveDialog" align="end">
            <DropdownMenuList>
              <DropdownMenuItem onClick={() => onStartCampaign(true)}>
                <ClockCounterClockwise />
                Schedule campaign
              </DropdownMenuItem>
            </DropdownMenuList>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Licenses
        isOpen={isLicensesModalOpen}
        setIsOpen={setIsLicensesModalOpen}
        accountIds={workerAccountsWithoutSeat.map(({ id }) => id)}
        newSeatsCount={missingSeatsCount}
      />

      <CampaignStart
        isOpen={isDialogOpen}
        isScheduled={isScheduled}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
